import * as actions from "./notification.actions";
import * as mutations from "./notification.mutations";
import * as getters from "./notification.getters";
import state from "./notification.state";
// make our modules namespaced to avoid method name conflicts
const namespaced = true;

const notification = {
  namespaced,
  getters,
  mutations,
  actions,
  state
};

export default notification;
